const contactUsProductType = document.getElementById('00N0c00000B95G4');
const contactUsProductDetail = document.getElementById('00N0c00000B95G9');
const contactUsProductDetailLabel = document.getElementById('00N0c00000B95G9_label');

// No Vue, not playing nicely with not being able to add modifiers to the form..
if(contactUsProductType)
{
	contactUsProductDetail.style.display = 'none';
	contactUsProductDetailLabel.style.display = 'none';

	var toggleHiddenProductDetail = function (event) {
	    if (event.target.value == "Event") {
	        contactUsProductDetail.style.display = 'block';
	        contactUsProductDetailLabel.style.display = 'block';
	    }
	    else {
	        contactUsProductDetail.style.display = 'none';
	        contactUsProductDetailLabel.style.display = 'none';
	        contactUsProductDetail.value = '';
	    }
	}
	contactUsProductType.addEventListener('click', toggleHiddenProductDetail);
	contactUsProductType.addEventListener('blur', toggleHiddenProductDetail);
}



// WEBPACK FOOTER //
// ../components/contact/contact.js